package features.notifications.ui.components

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import AppState

/**
 * Notification bell icon with badge counter
 */
object NotificationBell {
    fun render(parent: DIV) {
        parent.div("relative") {
            // Bell button
            button(classes = "relative p-2 rounded-full hover:bg-dark-700 transition") {
                onClickFunction = {
                    shared.ui.ModalManager.show("notification-list-modal")
                }
                
                // Bell icon - changes color when there are unread notifications
                val hasUnread = AppState.unreadNotificationCount > 0
                val iconColor = if (hasUnread) "text-brand-cyan" else "text-slate-400"
                
                span("text-2xl $iconColor") {
                    +"🔔"
                }
                
                // Badge counter (only show if count > 0)
                if (hasUnread) {
                    span("absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center") {
                        +AppState.unreadNotificationCount.toString()
                    }
                }
            }
        }
    }
}
